import React from 'react';
import {
  shallowEqual,
  // useDispatch,
  useSelector,
} from 'react-redux';
import { block } from 'bem-cn';

// import { useAppSelector } from 'shared/hooks';
// import { numberWithSpaces } from 'shared/helpers';

// import Select from 'components/Selectors/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
// import DateSwitcher from 'components/Date/Switcher/view/desktop';
// import CheckBox from 'components/CheckBox';

// import { IFiltersProps } from './types';
import './Filters.scss';
import DaysFilter from 'features/statistic/DaysFilter';

const b = block('statistic-filters-desktop');

const Filters = ({ model }) => {
  // const dispatch = useDispatch();

  const locale = useSelector(state => state.locale.locale, shallowEqual);
  // const locale2 = useSelector(state => state.locale.locale, shallowEqual);
  // const { totalDeposit, totalWithdraw } = useSelector(state => state.transfersHistory, shallowEqual);
  // const { currency } = useSelector(state => state.auth, shallowEqual);

  return (
    <form className={b()}>
      <span className={b('item-date-label')} />

      <div className={b('block')}>
        <div className={b('item-date-input')}>
          <div className={b('item-date-label')}>{locale.dateFrom}</div>
          <div className={b('input')}>
            <InputDate
              dateFormat="yyyy-MM-dd"
              selected={model.inputState.values.from}
              onChange={model.inputState.onChangeFrom}
            />
          </div>
        </div>
        <div className={b('item-date-input')}>
          <div className={b('item-date-label')}>{locale.dateTo}</div>
          <div className={b('input')}>
            <InputDate
              dateFormat="yyyy-MM-dd"
              selected={model.inputState.values.to}
              onChange={model.inputState.onChangeTo}
            />
          </div>
        </div>
        <div className={b('button')}>
          <Button callBack={model.outputState.onSubmit} text={locale.acceptFilter} />
        </div>
      </div>

      {/* <div className={b('button')}>
        <Button type="submit">
          <span className={b('button-text')}>{locale2.acceptFilter}</span>
        </Button>
      </div> */}

      <div className={b('block')}>
        <DaysFilter activeDay={model.outputState.activeDaySelect} setActiveDay={model.inputState.setActiveDay} />
      </div>
    </form>
  );
};

export default Filters;
